<ng-container *ngIf="vm$ | async as vm">
  <uni-box [isMargin]="'top'">
    <app-loading-mask *ngIf="vm.loading"></app-loading-mask>
    <uni-box-content [isVerticalSpace]="false">
      <header>
        <app-span>{{'ci.unishield.overview' | translate}}</app-span>
      </header>
      <app-blocked-cards
        [blocked]="vm.blocked"
        [savings]="vm.savings | number: '1.3-3'"
      ></app-blocked-cards>
    </uni-box-content>
  </uni-box>
</ng-container>
